/**
 * @prettier
 */
import { makeStyles } from '@material-ui/core';
import * as React from 'react';
import { useState } from 'react';
import { ContextualMenu } from 'src/components/ContextualMenu';
import { ContextualMenuItem } from 'src/components/ContextualMenuItem';
import { translate } from 'src/i18n/translate';
import { CopyRestaurantMenuDialog } from 'src/scenes/letseatmanager/menu/menu/CopyRestaurantMenuDialog';
import { ImportMenuFromCsvFileDialog } from 'src/scenes/letseatmanager/menu/menu/ImportMenuFromCsvFileDialog';
import { ImportRestaurantMenuDialog } from 'src/scenes/letseatmanager/menu/menu/ImportRestaurantMenuDialog';
import { useLoadRestaurantMenu } from 'src/services/restaurant/useLoadRestaurantMenu';
import { useSelector } from 'src/utils/react/useSelector';

export function AdvancedMenuOptions(): React.ReactElement | null {
    const classes = useStyles();

    const refreshMenus = useLoadRestaurantMenu();

    const [copyRestaurantMenuDialogState, setCopyRestaurantMenuDialogState] = useState({ open: false });
    const [importRestaurantMenuDialogState, setImportRestaurantMenuDialogState] = useState({ open: false });
    const [importMenuFromCsvFileDialogState, setImportMenuFromCsvFileDialogState] = useState({ open: false });

    const internalUser = useSelector((state) => state.authentication.internalUser);

    const openCopyRestaurantMenuDialog = () => setCopyRestaurantMenuDialogState({ open: true });

    const closeCopyRestaurantMenuDialog = () => setCopyRestaurantMenuDialogState({ open: false });

    const openImportRestaurantMenuDialog = () => setImportRestaurantMenuDialogState({ open: true });

    const closeImportRestaurantMenuDialog = () => setImportRestaurantMenuDialogState({ open: false });

    const openImportMenuFromCsvFileDialog = () => setImportMenuFromCsvFileDialogState({ open: true });

    const closeImportMenuFromCsvFileDialog = () => setImportMenuFromCsvFileDialogState({ open: false });

    const handleRefreshMenus = () => refreshMenus();

    if (!internalUser) return null;

    return (
        <div className={classes.container}>
            <CopyRestaurantMenuDialog open={copyRestaurantMenuDialogState.open} onClose={closeCopyRestaurantMenuDialog} onSuccess={handleRefreshMenus} />
            <ImportRestaurantMenuDialog open={importRestaurantMenuDialogState.open} onClose={closeImportRestaurantMenuDialog} />
            <ImportMenuFromCsvFileDialog open={importMenuFromCsvFileDialogState.open} onClose={closeImportMenuFromCsvFileDialog} onSuccess={handleRefreshMenus} />
            <ContextualMenu title={translate('Advanced options')}>
                <ContextualMenuItem onClick={openCopyRestaurantMenuDialog}>{translate('Copy Menu from other Restaurant')}</ContextualMenuItem>
                <ContextualMenuItem onClick={openImportRestaurantMenuDialog}>{translate('Import Menu from external URL')}</ContextualMenuItem>
                <ContextualMenuItem onClick={openImportMenuFromCsvFileDialog}>{translate('Import Menu From CSV File')}</ContextualMenuItem>
            </ContextualMenu>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    container: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    menuItem: {
        fontFamily: theme.typography.regular,
        fontSize: 15,
        display: 'flex',
        gap: 10,
    },
}));
